
<template>
  <div class="CJGG_HJ">
    <div class="title">结果公告</div>
    <div class="content_box">
      <p style="text-indent: 2em">
        <span style="text-decoration: underline">{{ detail.projectName }}</span
        >于<span style="text-decoration: underline">{{
          formatDate(detail.dealtime)
        }}</span
        >在获嘉县农村产权交易信息服务平台进行了公开竞价，现将交易结果予以公告。
      </p>
      <p style="text-indent: 2em">
        一、项目编号：<span style="text-decoration: underline">{{
          detail.projectNumber
        }}</span>
      </p>
      <p style="text-indent: 2em">
        二、公告发布时间：<span style="text-decoration: underline">{{
          detail.dealtime
        }}</span>
      </p>
      <p style="text-indent: 2em">
        三、项目成交时间：<span style="text-decoration: underline">{{
          detail.dealtime
        }}</span>
      </p>
      <p style="text-indent: 2em">四、项目交易情况：</p>
      <p style="text-indent: 2em">
        起始价：<span style="text-decoration: underline">{{
          detail.initPrice
        }}</span
        >元/年/{{ getDictValue(detail.areaUnit, "area_unit") }}
      </p>
      <p style="text-indent: 2em">
        成交价：<span style="text-decoration: underline">{{
          detail.transactionprice
        }}</span
        >元/年/{{ getDictValue(detail.areaUnit, "area_unit") }}
      </p>
      <p style="text-indent: 2em">
        数 量：<span style="text-decoration: underline">{{
          detail.area + detail.areaUnit
        }}</span>
      </p>
      <p style="text-indent: 2em">
        成交方：<span style="text-decoration: underline">{{
          detail.assignee
        }}</span>
      </p>
      <p style="text-indent: 2em">
        五、公告媒体：获嘉县农村产权交易信息服务平台
      </p>
      <p style="text-indent: 2em">六、监督管理部门电话：0373-4580015</p>
      <p style="text-indent: 4em">获嘉县农村产权交易中心电话：0373-4562910</p>
      <p style="text-indent: 4em">
        {{ detail.outName }}&nbsp;电话：{{ detail.phone }}
      </p>
      <p
        style="text-indent: 2em; text-align: right; text-decoration: underline"
      >
        {{ detail.outName }}
      </p>
      <p style="text-indent: 2em; text-align: right">
        {{ detail.dealtime.split("-")[0] }}年{{
          detail.dealtime.split("-")[1]
        }}月{{ detail.dealtime.split("-")[2] }}日
      </p>
    </div>
  </div>
</template>

<script>
import { get } from 'jquery'
import { getPublicityDetail } from '../api/mian'
import { getTypeList } from '../api/交易项目详情'

export default {
  data () {
    return {
      detail: {},
      dictList: {
        // 单位
        "area_unit": [],
        // 转出方式
        "out_type": [],
      }
    }
  },
  created () {
    getPublicityDetail({ id: this.$route.query.remark }).then(res => {
      this.detail = res.data.data
      console.log("成交公告详情信息", this.detail)
    })
    for (let dictTitle of Object.keys(this.dictList)) {
      getTypeList(dictTitle).then(res => {
        this.dictList[dictTitle] = res.data.data
      })
    }

  },
  mounted () { },
  computed: {},
  watch: {},
  methods: {
    formatDate (cellValue) {
      if (cellValue == null || cellValue == "") return ""
      var date = new Date(cellValue)
      var year = date.getFullYear()
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate()
      var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds()
      return (
        year + "年" + month + "月" + day + "日"
      )
    },
    // 获取字典值
    getDictValue (value, dictTitle) {
      if ((value !== 0 && value !== '0') && !value) return "暂无"
      return this.dictList[dictTitle].find((item) => item.dictValue == value) ? this.dictList[dictTitle].find((item) => item.dictValue == value).dictLabel : "暂无"
    },
  },
};
</script>
<style scoped lang="scss">
.CJGG_HJ {
  width: 1420px;
  height: auto;
  margin: 0 auto;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
  padding: 41px 200px 60px 200px;
  min-height: 500px;
  .title {
    text-align: center;
    font-size: 30px;
    font-weight: 600;
  }
  .content_box {
    margin-top: 20px;
    p {
      line-height: 2;
      font-size: 24px;
    }
  }
}
</style>